// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
enum FontWeights {
  Thin = 100 /* Hairline */,
  ExtraLight = 200 /* Ultra Light */,
  Light = 300,
  Normal = 400 /* Regular */,
  Medium = 500,
  SemiBold = 600 /* Demi Bold */,
  Bold = 700,
  ExtraBold = 800 /* Ultra Bold */,
  Black = 900 /* Heavy */,
  ExtraBlack = 950 /* Ultra Black */,
}

export default FontWeights;
